// extracted by mini-css-extract-plugin
module.exports = {"creditsText":"MessageEstimate_creditsText__rCOia","estimate":"MessageEstimate_estimate__CUyXO","error":"MessageEstimate_error__pEOfQ","icon":"MessageEstimate_icon__O1h1b"};